<template>
  <div>
    <a-form
      class="form-container"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-row :gutter="[30, 30]">
        <a-col :xs="24" :sm="24" :md="8">
          <a-form-item :label="$t('order.order_date')" :colon="false">
            <a-range-picker v-model:value="queryParam.dateRange" />
          </a-form-item>
        </a-col>
        <a-col :xs="24" :sm="24" :md="6">
          <a-form-item :label="$t('order.order_no')" :colon="false">
            <a-input
              @pressEnter="handleSearch"
              v-model:value="queryParam.orderNo"
            />
          </a-form-item>
        </a-col>
        <a-col :xs="24" :sm="24" :md="6">
          <a-form-item :label="$t('order.order_consignee')" :colon="false">
            <a-input
              @pressEnter="handleSearch"
              v-model:value="queryParam.consignee"
            >
            </a-input>
          </a-form-item>
        </a-col>
        <a-col :xs="24" :sm="24" :md="4">
          <a-form-item :wrapper-col="{ span: 24 }">
            <div class="action-container">
              <a-button
                @click="handleSearch"
                class="j-origin-padding search-btn"
                type="primary"
              >
                {{ $t('order.search') }}
              </a-button>
              <a-button
                @click="handleReset"
                class="j-origin-padding j-outline-btn1 search-btn"
              >
                {{ $t('order.reset') }}
              </a-button>
            </div>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>

    <div class="table-container">
      <a-table
        :loading="loading"
        :pagination="ipagination"
        :columns="columns"
        size="middle"
        row-key="id"
        :data-source="dataSource"
      >
        <template #[`${col}-title`] v-for="col in colTitle" :key="col">
          {{ $t(`order.${col}`) }}
        </template>

        <template #order-date="{text}">
          {{ text ? moment(text).format('YYYY-MM-DD') : '' }}
        </template>

        <template #unit="{text}">
          {{ text ? $t(text) : '' }}
        </template>

        <template #orderStatus="{text}">
          {{ getOrderStatus(text) }}
        </template>

        <template #totalPrice="{record}">
          {{ getTotalPrice(record) }}
        </template>

        <template #logistics="{record}">
          <a @click="goToLogDetail(record)">{{ $t('order.logistics') }}</a>
        </template>

        <template #order-no="{text, record}">
          <a @click="goToDetail(record)">{{ text }}</a>
        </template>

        <!-- <template #remark="{text, record}">
          <div class="editable-cell">
            <div v-if="record.editable" class="editable-cell-input-wrapper">
              <a-textarea
                :maxLength="150"
                v-model:value="record.remark"
                @pressEnter="handleSave(record)"
              />
              <check-outlined
                class="editable-cell-icon-check"
                @click="handleSave(record)"
              />
            </div>
            <div v-else class="editable-cell-text-wrapper">
              {{ text || ' ' }}
              <edit-outlined
                class="editable-cell-icon"
                @click="handleEdit(record)"
              />
            </div>
          </div>
        </template> -->
      </a-table>

      <div class="pagination-container">
        <a-pagination
          v-model:current="ipagination.current"
          :page-size-options="ipagination.pageSizeOptions"
          :total="ipagination.total"
          show-size-changer
          v-model:pageSize="ipagination.pageSize"
          @showSizeChange="onShowSizeChange"
          @change="onChange"
          size="small"
          show-quick-jumper
        >
          <template #buildOptionText="props">
            <span>{{ props.value }} {{ $t('common.page_per_item_text') }}</span>
          </template>
        </a-pagination>
      </div>

      <div class="table-summary">
        <div>{{ $t('order.total_price_label') }}</div>
        <!-- <div class="price">{{ totalSummary }}</div> -->
        <div class="price">
          <div v-for="(item, index) in groupedDataSource" :key="index">
            {{ getTotalSummary(item) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
// import { CheckOutlined, EditOutlined } from '@ant-design/icons-vue';
import moment from 'moment';
import numeral from 'numeral';
import groupBy from 'lodash.groupby';
import { getOrderList, modifyOrder } from '@/api/apis';
import { dollarCode } from '@/utils/constants';

interface VehicleOrderProps {
  dataSource: any[];
  moneyTypeList: any[];
  groupedDataSource: any;
  [key: string]: any;
}

export default defineComponent({
  name: 'VehicleOrder',
  components: {
    // CheckOutlined,
    // EditOutlined
  },
  props: {
    moneyTypes: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data(): VehicleOrderProps {
    return {
      moment,
      numeral,
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      queryParam: {
        consignee: '',
        orderNo: '',
        dateRange: []
      },
      loading: false,
      colTitle: [
        'order_no',
        'order_consignee',
        'order_date',
        'unit',
        'quantity',
        'total_price',
        'consignee',
        'remark',
        'status',
        'logistics'
      ],
      columns: [
        {
          dataIndex: 'orderNum',
          width: 100,
          slots: { customRender: 'order-no', title: 'order_no-title' }
        },
        {
          dataIndex: 'consignee',
          width: 120,
          slots: { title: 'order_consignee-title' }
        },
        {
          dataIndex: 'createTime',
          width: 100,
          slots: { customRender: 'order-date', title: 'order_date-title' }
        },
        {
          dataIndex: 'unit',
          width: 100,
          slots: { customRender: 'unit', title: 'unit-title' }
        },
        {
          dataIndex: 'totalQuantity',
          width: 100,
          slots: { customRender: 'totalQuantity', title: 'quantity-title' }
        },
        {
          dataIndex: 'totalPrice',
          width: 100,
          slots: { customRender: 'totalPrice', title: 'total_price-title' }
        },
        {
          dataIndex: 'orderStatus',
          width: 100,
          slots: { customRender: 'orderStatus', title: 'status-title' }
        },
        {
          width: 100,
          slots: { customRender: 'logistics', title: 'logistics-title' }
        },
        {
          width: 120,
          dataIndex: 'remark',
          slots: { title: 'remark-title' }
        }
      ],
      ipagination: {
        current: 1,
        pageSizeOptions: ['5', '10', '15'],
        total: 0,
        showSizeChanger: true,
        pageSize: 5,
        showQuickJumper: true
        // size: 'large'
      },
      dataSource: [],
      // total price
      moneyTypeList: [],
      groupedDataSource: {}
    };
  },
  computed: {
    totalSummary() {
      let res = numeral(0);

      this.dataSource.forEach(d => {
        res = res.add(d.totalSellingPrice || 0);
      });

      return res.format('$0,0.00');
    }
  },
  created() {
    this.loadData();
  },
  methods: {
    getTotalSummary(moneyType) {
      let res = numeral(0);

      this.dataSource
        .filter(s => s.moneyType === moneyType)
        .forEach(d => {
          res = res.add(d.totalSellingPrice || 0);
        });

      return this.$t(moneyType) + res.format('0,0.00');
    },
    getTotalPrice(record) {
      const res = numeral(0);

      record.offSellingPrice
        ? res.add(record.offSellingPrice || 0)
        : res.add(record.totalSellingPrice || 0);
      const currency = this.getCurrency(record);

      const value = res.value();
      return value ? currency + res.format('0,0.00') : '';
    },
    // called from parent
    getFilter() {
      return {
        startTime:
          this.queryParam.dateRange.length > 0
            ? moment(this.queryParam.dateRange[0]).format('YYYY-MM-DD')
            : '',
        endTime:
          this.queryParam.dateRange.length > 0
            ? moment(this.queryParam.dateRange[1]).format('YYYY-MM-DD')
            : '',
        orderNum: this.queryParam.orderNo,
        consignee: this.queryParam.consignee
      };
    },
    getCurrency(record) {
      let res = '';
      const moneyType = record.moneyType;

      if (moneyType) {
        const item: any = this.moneyTypes.find(
          (s: any) => s.code === moneyType
        );

        res = item ? item.val : '';
      }
      return res;
    },
    getOrderStatus(status) {
      let res = '';

      if (!isNaN(status) && status !== null && status >= 0) {
        res = this.$t(`order_status.${status}`);
      }
      return res;
    },
    goToLogDetail(record) {
      this.$router.push(
        `/vehicle-logistics-info/${record.id}?orderNo=${record.orderNum}`
      );
    },
    goToDetail(record) {
      this.$router.push(`/vehicle-order-detail/${record.id}`);
    },
    async loadData() {
      this.loading = true;

      const res = await getOrderList({
        pageNo: this.ipagination.current,
        pageSize: this.ipagination.pageSize,
        orderType: 1,
        startTime:
          this.queryParam.dateRange.length > 0
            ? moment(this.queryParam.dateRange[0]).format('YYYY-MM-DD')
            : null,
        endTime:
          this.queryParam.dateRange.length > 0
            ? moment(this.queryParam.dateRange[1]).format('YYYY-MM-DD')
            : null,
        orderNum: this.queryParam.orderNo,
        consignee: this.queryParam.consignee
      });

      if (res.success) {
        this.ipagination.total = res.result.total;
        this.dataSource = res.result.records || [];

        this.dataSource.forEach(d => {
          if (!d.moneyType) {
            d.moneyType = dollarCode;
          }
        });

        const groupedData = groupBy(this.dataSource, d => d.moneyType);

        this.groupedDataSource = Object.keys(groupedData);
      }

      this.loading = false;
    },
    onShowSizeChange(current) {
      this.ipagination.current = current;

      this.loadData();
    },
    onChange(page, pageSize) {
      this.ipagination.current = page;
      this.ipagination.pageSize = pageSize;

      this.loadData();
    },
    async handleSave(record) {
      const res = await modifyOrder({
        ...record
      });

      if (res.success) {
        record.editable = false;
      }
    },
    handleEdit(record) {
      record.editable = true;
    },
    handleSearch() {
      this.ipagination.current = 1;
      this.loadData();
    },
    handleReset() {
      this.queryParam = {
        consignee: '',
        orderNo: '',
        dateRange: []
      };

      this.loadData();
    }
  }
});
</script>

<style lang="scss" scoped>
.form-container {
  margin-bottom: 30px;

  .action-container {
    text-align: right;
  }

  .search-btn {
    &:first-child {
      margin-right: 8px;
    }
  }

  ::v-deep(.ant-form-item) {
    margin-right: 0;
    margin-bottom: 0;
  }
}

.table-container {
  margin-bottom: 30px;
}

.table-summary {
  margin-bottom: 40px;
  background: #e5eaf4;
  /* height: 60px; */
  padding: 8px 0;

  display: flex;
  align-items: center;
  justify-content: flex-end;

  .price {
    font-size: $secondary-fontsize;
    color: $primary-color;
    font-weight: bold;
    margin: 0 40px 0 20px;
  }
}

.pagination-container {
  margin: 20px 0;
  text-align: right;
}

// 隐藏table自带的pagination
::v-deep(.ant-table-pagination) {
  display: none;
}
</style>
